import { endOfDay, isAfter, startOfDay, subDays } from 'date-fns';

/*
 * We will soon deprecate moment in favor of date-fns.
 * Moment is still required here due to the DateRange component.
 */
import moment from 'moment';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';

import DateRange from '../../common/DateRange/DateRange';
import { DateIcon } from '../../icons/analytics';
import { ANALYTICS_START_DATE } from '../../tables/reports/consts';
import { ANALYTICS_SET_FILTER } from '../../../store/reducers/analytics';

import styles from './AnalyticsDateFilter.module.scss';

const ANALYTICS_PREFIX = 'analytics';
const ANALYTICS_DATE_PICKER_INITIAL_START_DATE = moment().subtract(7, 'days').startOf('day');

export function AnalyticsDateFilter({ onChange, showToday = true, keyPrefix = ANALYTICS_PREFIX }) {
  const dispatch = useDispatch();
  const { dates } = useSelector((state) => state.analytics.filters);

  const maxDate = showToday ? undefined : endOfDay(subDays(new Date(), 1));

  if (showToday && maxDate) {
    if (isAfter(dates.start, maxDate)) {
      dispatch({
        type: ANALYTICS_SET_FILTER,
        payload: { dates: { start: startOfDay(maxDate), end: maxDate } },
      });
    } else if (isAfter(dates.end, maxDate)) {
      dispatch({
        type: ANALYTICS_SET_FILTER,
        payload: { dates: { end: maxDate } },
      });
    }
  }

  return (
    <div className={styles.dateFilterWrapper}>
      <div className={styles.dateRangeWrapper}>
        <DateIcon />
        <DateRange
          onChange={onChange}
          startDateStorageKey={`${keyPrefix}StartDate`}
          endDateStorageKey={`${keyPrefix}EndDate`}
          limitToMonth={false}
          minDate={ANALYTICS_START_DATE}
          maxDate={maxDate}
          initialStartDate={ANALYTICS_DATE_PICKER_INITIAL_START_DATE}
        />
      </div>
    </div>
  );
}

AnalyticsDateFilter.propTypes = {
  onChange: PropTypes.func.isRequired,
  showToday: PropTypes.bool,
};
